import {
  AndroidSVG,
  AppleSVG,
  DiscordSVG,
  HomeSVG,
  MacOsSVG,
  TelegramSVG,
  TwitterSVG,
  WindowsSVG,
} from "../../../assets";
import "./SocialLinks.scss";

interface SocialLinksProps {
  discordLink?: string;
  twitterLink?: string;
  telegramLink?: string;
  homeLink?: string;
  androidLink?: string;
  appleLink?: string;
  windowsLink?: string;
  macOsLink?: string;
}

export const SocialLinks = ({
  discordLink,
  twitterLink,
  telegramLink,
  homeLink,
  androidLink,
  appleLink,
  windowsLink,
  macOsLink,
}: SocialLinksProps) => {
  return (
    <ul className="social-links__icons">
      {discordLink && (
        <li className="social-links__icon">
          <a
            href={discordLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to Discord"
          >
            <DiscordSVG />
          </a>
        </li>
      )}

      {twitterLink && (
        <li className="social-links__icon">
          <a
            href={twitterLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to Twitter"
          >
            <TwitterSVG />
          </a>
        </li>
      )}

      {telegramLink && (
        <li className="social-links__icon">
          <a
            href={telegramLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to Telegram"
          >
            <TelegramSVG />
          </a>
        </li>
      )}

      {homeLink && (
        <li className="social-links__icon">
          <a
            href={homeLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to Homepage"
          >
            <HomeSVG />
          </a>
        </li>
      )}

      {androidLink && (
        <li className="social-links__icon">
          <a
            href={androidLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to google play"
          >
            <AndroidSVG />
          </a>
        </li>
      )}

      {appleLink && (
        <li className="social-links__icon">
          <a
            href={appleLink}
            target="_blank"
            rel="noreferrer"
            aria-label="Go to apple store"
          >
            <AppleSVG />
          </a>
        </li>
      )}

      {windowsLink && (
        <li className="social-links__icon">
          <a href={windowsLink} target="_blank" rel="noreferrer">
            <WindowsSVG />
          </a>
        </li>
      )}

      {macOsLink && (
        <li className="social-links__icon">
          <a href={macOsLink} target="_blank" rel="noreferrer">
            <MacOsSVG />
          </a>
        </li>
      )}
    </ul>
  );
};
